import { useEffect, useState } from "react";
import api from "../lib/api";
import { BellRing, CheckCheck } from "lucide-react";

const dt = (s) => new Date(s).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short", timeZone: "Asia/Kolkata" });
const toneCls = { alert: "border-l-4 border-l-[#BB162B]", warning: "border-l-4 border-l-amber-400", success: "border-l-4 border-l-emerald-500", action: "border-l-4 border-l-[#BF9B30]", info: "border-l-4 border-l-slate-300" };

export default function Notifications() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/notifications").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const markAll = async () => { await api.post("/notifications/read-all"); load(); };

  return (
    <div className="px-4 py-5 lg:px-8 max-w-2xl">
      <div className="flex items-center justify-between">
        <h1 className="font-heading text-2xl font-bold text-[#0E2240]">Alerts</h1>
        <button data-testid="mark-all-read-btn" onClick={markAll} className="flex items-center gap-1.5 text-xs font-bold text-slate-500"><CheckCheck size={14} /> Mark all read</button>
      </div>
      <div className="mt-4 space-y-2">
        {items.length === 0 && (
          <div className="rounded-xl border border-dashed border-slate-200 p-10 text-center text-sm text-slate-400">
            <BellRing className="mx-auto mb-2 text-slate-300" size={24} /> No alerts yet
          </div>
        )}
        {items.map((n) => (
          <div key={n.id} className={`rounded-xl border border-slate-200 bg-white p-3.5 ${toneCls[n.type] || toneCls.info} ${n.read ? "opacity-60" : ""}`}>
            <div className="text-sm font-bold text-[#0E2240]">{n.title}</div>
            <div className="mt-0.5 text-xs text-slate-500">{n.body}</div>
            <div className="mt-1 text-[10px] text-slate-400">{dt(n.created_at)}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
